import React from "react"
import {
  Box, Heading, Text,
} from "@chakra-ui/react"
import GoogleMapReact from "google-map-react"
import { join } from "services/utilities"
import { Website } from "sharedTypes"
import ActionButton from "./ActionButton"

const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_KEY

const GoogleMap = ({
  website: {
    mapEnabled,
    latitude,
    longitude,
    locationVenue,
    locationLine1,
    locationLine2,
    locationLine3,
    rsvpButtonColor,
  },
}: {
  website: Website
}) => {
  if (!mapEnabled || !latitude || !longitude) {
    return null
  }

  const center = { lat: parseFloat(latitude), lng: parseFloat(longitude) }
  const directionsHref = () => `https://maps.google.com?&key=${GOOGLE_MAPS_KEY}&saddr=Current+Location&daddr=${join([
    locationLine1,
    locationLine2,
    locationLine3,
  ])}`

  return (
    <Box w="100%" h="480px" pos="relative">
      <Box
        bgColor="white"
        left="15px"
        minHeight="180px"
        p={5}
        pos="absolute"
        textAlign="center"
        top="15px"
        w="300px"
        zIndex={1}
      >
        <Box mb={3}>
          <Heading fontWeight="bold" fontSize="2xl" mb={2}>
            {locationVenue}
          </Heading>
          <Text>{locationLine1}</Text>
          <Text>{locationLine2}</Text>
          <Text>{locationLine3}</Text>
        </Box>
        <ActionButton
          text="Directions"
          color={rsvpButtonColor}
          buttonClick={() => window.open(directionsHref())}
        />
      </Box>
      <GoogleMapReact
        bootstrapURLKeys={{ key: GOOGLE_MAPS_KEY }}
        defaultCenter={center}
        defaultZoom={16}
        resetBoundsOnResize={false}
        {...({ options: { scrollwheel: false } } as object)}
      >
        <GoogleMapMarker lat={center.lat} lng={center.lng} />
      </GoogleMapReact>
    </Box>
  )
}

// Marker position is set by google-map-react via lat/lng; we only render the pin image
const GoogleMapMarker: React.FC<{ lat: number; lng: number }> = () => (
  <Box as="img" src="/pin.png" width={30} height={49} alt="" />
)

export default GoogleMap
